import { ENVIRONMENT } from "@cda-libs/cda-const";

export const environment = ENVIRONMENT;
